import { queryOptions } from "@tanstack/react-query";

import { $getCourse, $getCourseTree, $listCourses } from "@/server/actions/course";

export const courseListQueryOptions = () =>
	queryOptions({
		queryKey: ["courses"],
		queryFn: () => $listCourses(),
	});

export const courseDetailQueryOptions = (courseId: string) =>
	queryOptions({
		queryKey: ["courses", courseId],
		queryFn: () => $getCourse({ data: { courseId } }),
	});

export const courseTreeQueryOptions = (courseId: string) =>
	queryOptions({
		queryKey: ["courses", courseId, "tree"],
		queryFn: () => $getCourseTree({ data: { courseId } }),
	});
